import {atom} from "jotai";

export const tipoDocumentosAtom = atom([]);